import WidgetDateTimePicker from 'components/Widgets/WidgetDateTimePicker';
import dayjs from 'dayjs';

const TimeTypeField = ({ selectItem, setNewSelectItem, disabled }) => {
  return (
    <WidgetDateTimePicker
      selected={selectItem?.value}
      onChange={(val) =>
        setNewSelectItem({
          value: dayjs(val).format('HH:mm') ?? ' ',
          setting: { date: dayjs(val).format('HH:mm') },
        })
      }
      isTime={true}
      disabled={disabled}
    />
  );
};

export default TimeTypeField;
